import React, { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Loading from "./components/jsx/home/Loading";
import { SearchContextProvider } from "./context/SearchContext";

// Layouts
import MainLayout from "./layout/MainLayout";
import UserLayout from "./layout/UserLayout";

// Lazy-loaded components
const Home = lazy(() => import("./pages/home/Home"));
const List = lazy(() => import("./pages/list/List"));
const Room = lazy(() => import("./pages/room/Room"));
const PaymentPage = lazy(() => import("./pages/payment/Payment"));
const Login = lazy(() => import("./pages/login/Login"));
const Register = lazy(() => import("./pages/register/Register"));
const Profil = lazy(() => import("./pages/user/profile/profil"));
const HotelList = lazy(() => import("./pages/hotelList/HotelList"));
const Hotel = lazy(() => import("./pages/hotel/Hotel"));
const Bookings = lazy(() => import("./pages/user/bookings/Bookings"));
const Favorites = lazy(() => import("./pages/user/favories/favory"));
const Profilimg = lazy(() =>
  import("./pages/user/profile/settings/jsx/profilimg")
);
const Security = lazy(() =>
  import("./pages/user/profile/settings/jsx/security")
);
const Properties = lazy(() =>
  import("./pages/hotelList/propreties/Properties")
);
const InfoUser = lazy(() =>
  import("./pages/user/profile/settings/jsx/infoUser")
);
const UserCompte = lazy(() =>
  import("./pages/user/profile/settings/jsx/compte")
);
const PaiementUser = lazy(() =>
  import("./pages/user/profile/settings/jsx/paiementMode")
);

function App() {
  return (
    <BrowserRouter>
      <SearchContextProvider>
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/" element={<MainLayout />}>
              <Route index element={<Home />} />
              <Route path="rooms">
                <Route index element={<List />} />
                <Route path=":id" element={<Room />} />
                <Route path=":id/payment" element={<PaymentPage />} />
              </Route>
              <Route path="hotels">
                <Route path=":id" element={<Hotel />} />
              </Route>
              <Route path="hotelList" element={<HotelList />} />
              <Route path="properties/:type" element={<Properties />} />
              <Route path="bookings" element={<Bookings />} />
              <Route path="favories" element={<Favorites />} />
            </Route>

            <Route path="/profil" element={<UserLayout />}>
              <Route index element={<Profil />} />
              <Route path="img" element={<Profilimg />} />
              <Route path="infouser">
                <Route index element={<InfoUser />} />
              </Route>
              <Route path="account">
                <Route index element={<UserCompte />} />
              </Route>
              <Route path="paymentuse">
                <Route index element={<PaiementUser />} />
              </Route>
              <Route path="security" element={<Security />} />
            </Route>

            <Route path="login" element={<Login />} />
            <Route path="register" element={<Register />} />
          </Routes>
        </Suspense>
      </SearchContextProvider>
    </BrowserRouter>
  );
}

export default App;
